import { useQuery } from "@tanstack/react-query";
import { MessageCircle } from "lucide-react";
import { api } from "~/lib/api";

export function useOpsUnread() {
  return useQuery({
    queryKey: ["ops", "unread"],
    queryFn: () => api.ops.unread(),
    staleTime: 3000,
  });
}

export function UnreadPill({ count }: { count: number }) {
  return (
    <span className="bg-primary text-primary-foreground inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium tabular">
      <MessageCircle className="size-3" strokeWidth={2.25} />
      {count}
    </span>
  );
}

export function ParcelUnread({ parcelId }: { parcelId?: string | null }) {
  const { data } = useOpsUnread();
  const n = parcelId ? data?.parcel[parcelId] ?? 0 : 0;
  if (n <= 0) return null;
  return <UnreadPill count={n} />;
}
